import React from "react";
import Content from "./Content";
import styled from "styled-components";
import Draggable from "react-draggable";
import { useSelector } from "react-redux";

const MetaDataModal = (props) => {
  const { info, handleToggleModal } = props;
  const showObliquesModal = useSelector(state => state.settings.showObliquesModal);
  
  const Wrapper = styled.div`
    z-index: 2;
    overflow: hidden;
    position: fixed;
    top: 4rem;
    right: ${showObliquesModal ? "40rem" : "4rem"};
    width: 32.2rem;
    background: ${({ theme }) => theme.backgroundColor.locationModal.modal};
    color: ${({ theme }) => theme.textColor.secondary};
    border-radius: ${({ theme }) => theme.borderRadius.default};
    @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
      display: none;
    }
  `;

  return (
    <Draggable>
      <Wrapper>
        <Content info={info} handleToggleModal={handleToggleModal} />
      </Wrapper>
    </Draggable>
  );
};

export default MetaDataModal;